<template>
    <div class="mobile-only">
        <button
            class="mobile-filter-toggle"
            @click="show = !show"
            :class="{ opened: show }"
        >
            <i class="material-icons" v-show="!show">tune</i>
            <i class="material-icons" v-show="show">close</i>
        </button>
        <div class="filter-status-mobile mobile-only" v-if="show">
            <div class="filter-status-modal-title">Filters</div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "MobileFilters",
    props: ["value"],
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.mobile-filter-toggle {
    position: fixed;
    bottom: 40px;
    right: 20px;
    background-color: #ff5c00;
    width: 40px;
    height: 40px;
    line-height: 0.2;
    border-radius: 100%;
    border: none;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    z-index: 7;
    outline: none;
    &.opened {
        bottom: 140px;
    }
    .material-icons {
        color: #ffffff;
    }
}

.filter-status-mobile {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border-top: 1px solid #ededed;
    box-shadow: 2px 2px 18px rgba(155, 155, 155, 0.6);
    z-index: 6;
    padding-bottom: 8px;
}

.filter-status-modal-title {
    background-color: #ededed;
    height: 38px;
    line-height: 1.8;
    font-size: 18px;
    padding-left: 20px;
    border-bottom: 1px solid $grey;
}
</style>